import { checkout } from './checkout.de';
import { cookies } from './cookies.de';
import { footer } from './footer';
import { forms } from './forms.de';
import { notifications } from './notifications.de';
import { login } from './login.de';
import { register } from './register.de';
import { orderDetails } from './order-details.de';
import { actions } from './actions.de';
import { repairAnalysisInfo } from './repairAnalysisInfo.de';
import { processingSteps } from './processing-steps.de';
import { discount } from './discount.de';
import { welcomeJomatik } from './welcome-jomatik.de';
import { printmode } from './printmode.de';
import { account } from './account.de';
import { navigation } from './navigation.de';
import { oneMurtfeldtNotification } from './oneMurtfeldtNotification.js';
import { portalNotice } from './portalNotice.de.js';

export const de = {
    checkout,
    cookies,
    footer,
    notifications,
    register,
    login,
    orderDetails,
    actions,
    repairAnalysisInfo,
    processingSteps,
    discount,
    welcomeJomatik,
    printMode: printmode,
    forms,
    account,
    navigation,
    oneMurtfeldtNotification,
    portalNotice
};
